import FunnelSettings from './Funnel';
export default FunnelSettings;